module.exports = __webpack_public_path__ + "static/media/8.b570f023.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/8.png
// module id = 1436
// module chunks = 0